module.exports = __webpack_public_path__ + "images/product_jalapeno_2.c2b5c2a2.jpg";